module.exports = __webpack_public_path__ + "img/asset14.b905cbb7.svg";